<div id="rectangles" (window:resize)="resize()"></div>
